import firebase from 'firebase'

export const sendPairingEmails = async (registrationWeekStartDate: number) => {

    const callable = firebase.functions().httpsCallable('sendPairingEmails')
    return callable({ registrationWeekStartDate } as { registrationWeekStartDate: number })
    
}